import { t } from '@/lib/i18n';

export function Unauthorized() {
    return <div>{t('label.needs_auth')}</div>;
}
